import React from 'react';
import { get } from 'lodash';
import { Toggle } from '@ubeya/shared-web/components';

const PositionMappedToSupplierToggleRenderer = ({ dataKey, rowData, columnData: { onChange, readOnly = false } }) => {
  if (!rowData.positionId) {
    return <></>;
  }

  const value = get(rowData, dataKey);

  return (
    <Toggle
      value={value}
      isDisabled={readOnly}
      onChange={(val, e) => {
        e.stopPropagation();
        onChange(rowData.positionId, val);
      }}
    />
  );
};

export default PositionMappedToSupplierToggleRenderer;
